module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "tooltip-elem"
  }, [_vm._v(_vm._s(_vm.texto) + "\r\n    "), _c('span', {
    staticClass: "tooltiptext-elem",
    class: _vm.pos
  }, [_vm._v(_vm._s(_vm.tooltip))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8ec840","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Tooltip.vue
// module id = 952
// module chunks = 1